import React, { useEffect, useState } from "react";
import "../css/productlist.css";
import { Form } from "react-bootstrap";
import Listproduct from "./Listproduct";
import BestProduct from "./BestProduct";
import Pagination from "./Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTh, faBars } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import baseUrl from "../../src/Config/url.js";
import { useLocation, useNavigate } from "react-router-dom";
import {
  faBroadcastTower,
  faServer,
  faSyncAlt,
} from "@fortawesome/free-solid-svg-icons";

function Productlist() {
  const navigate = useNavigate();
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [columnList, setColumnList] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Radio");

  const imageBaseUrl =
    "https://admin.akenterprisessec.org/public/uploads/radio";

  const dummyData = {
    "Base Station": [
      {
        id: 101,
        name: "Base Station Alpha",
        image: `${imageBaseUrl}/default.jpg`,
      },
      {
        id: 102,
        name: "Base Station Beta",
        image: `${imageBaseUrl}/default.jpg`,
      },
    ],
    Repeaters: [
      {
        id: 201,
        name: "Repeater X",
        image: `${imageBaseUrl}/default.jpg`,
      },
      {
        id: 202,
        name: "Repeater Y",
        image: `${imageBaseUrl}/default.jpg`,
      },
    ],
  };

  const fetchProducts = async () => {
    setLoading(true);
    setError("");
    const category = location.state?.category || "Motorola";
    try {
      const response = await axios.get(`${baseUrl[1]}/radio/${category}`, {
        headers: { Accept: "application/json" },
      });
      const data = response.data.product;
      const categoryData = Array.isArray(data) ? data : [];
      const updatedProducts = categoryData.map((product) => {
        const fileName = product.image?.split("/").pop();
        return {
          id: product.id,
          name: product.name,
          type: product.type,
          model: product.model,
          series: product.series,
          make_origin: product.make_origin,
          company: product.company,
          description: product.description,
          battery_life: product.battery_life,
          power_output: product.power_output,
          frequency_range: product.frequency_range,
          image: fileName
            ? `${imageBaseUrl}/${fileName}`
            : `${imageBaseUrl}/default.jpg`,
          document: product.document,
        };
      });
      setProducts(updatedProducts);
    } catch (err) {
      console.error("API Error:", err);
      setError("Failed to fetch products. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleProductClick = (product) => {
    navigate("/product-detail", { state: { product } });
  };

  useEffect(() => {
    if (selectedCategory === "Radio") {
      fetchProducts();
    } else {
      setProducts(dummyData[selectedCategory] || []);
      setLoading(false);
    }
  }, [selectedCategory, location.state?.category]);

  return (
    <div className="product-list">
      <div className="content">
        <div className="category-tabs">
          <button
            onClick={() => setSelectedCategory("Radio")}
            className={selectedCategory === "Radio" ? "active" : ""}
          >
            <div className="tab-content">
              <FontAwesomeIcon icon={faBroadcastTower} />
              <span>Radio</span>
            </div>
          </button>
          <button
            onClick={() => setSelectedCategory("Base Station")}
            className={selectedCategory === "Base Station" ? "active" : ""}
          >
            <div className="tab-content">
              <FontAwesomeIcon icon={faServer} />
              <span>Base Station</span>
            </div>
          </button>
          <button
            onClick={() => setSelectedCategory("Repeaters")}
            className={selectedCategory === "Repeaters" ? "active" : ""}
          >
            <div className="tab-content">
              <FontAwesomeIcon icon={faSyncAlt} />
              <span>Repeaters</span>
            </div>
          </button>
        </div>

        {loading ? (
          <p>Loading products...</p>
        ) : error ? (
          <p style={{ color: "red" }}>{error}</p>
        ) : products.length === 0 ? (
          <p>No products found.</p>
        ) : (
          <div className={columnList ? "main-column-list" : "main-list"}>
            {products.map((product, index) => (
              <div
                className="column-product"
                key={index}
                onClick={() => handleProductClick(product)}
              >
                {columnList ? (
                  <BestProduct name={product.name} src={product.image} />
                ) : (
                  <Listproduct name={product.name} src={product.image} />
                )}
              </div>
            ))}
            <Pagination
              currentPage={currentPage}
              totalPages={1}
              onPageChange={setCurrentPage}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Productlist;
